import { BaseNode, NodeBadge } from './BaseNode';

export function CryptoNode({
  data,
}: {
  data: { label: string; alias?: string; algorithm?: string; input?: string; normalize?: string };
}) {
  return (
    <BaseNode
      type="crypto"
      label={data.label}
      alias={data.alias ? `${data.alias}.value` : undefined}
      badge={<NodeBadge>{data.algorithm ?? 'sha256'}</NodeBadge>}
      lines={[
        { text: data.input, mono: true },
        data.normalize && { text: data.normalize },
      ]}
    />
  );
}
